module.exports = __webpack_public_path__ + "img/user-blue-bg.43a7b75e.svg";